import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-staying-icon',
  templateUrl: './staying-icon.component.html',
  styles: []
})
export class StayingIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
